var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-empty',{attrs:{"description":"暂无相关数据"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }